import React from 'react';

import { getTranslation } from 'helpers/getTranslation';

import { DefaultModal } from 'components/DefaultModal';

const RemoveFileModal = ({
  open,
  loading,
  removeTitle,
  removeText,
  fileName,
  onClose,
  onCancelClick,
  onConfirmClick,
}: {
  open: any;
  loading: any;
  removeTitle: any;
  removeText: any;
  fileName: any;
  onClose: any;
  onCancelClick: any;
  onConfirmClick: any;
}) => (
  <DefaultModal
    open={open}
    loading={loading}
    title={removeTitle}
    text={
      typeof removeText === 'string' ? removeText : removeText({ fileName })
    }
    confirmText={getTranslation('components.remove_file_modal.confirm_text')}
    onConfirmClick={onConfirmClick}
    onCancelClick={onCancelClick}
    onClose={onClose}
  />
);

RemoveFileModal.defaultProps = {
  removeTitle: getTranslation('components.remove_file_modal.title'),
  removeText: getTranslation('components.remove_file_modal.text'),
};

export default React.memo(RemoveFileModal) as any;
